// Syd's House — force portrait hero on mobile
// Sense JS sets inline min-height on the slideshow banner element after load.
// The banner is .slideshow.banner (compound class — SAME element, not a descendant).
// This strips those inline styles on mobile so the adapt_image aspect ratio takes effect.
(function () {
  if (window.innerWidth >= 750) return;

  function stripHeight(el) {
    el.style.removeProperty('min-height');
    el.style.removeProperty('height');
  }

  function fixBanners() {
    // Compound selector: element that has BOTH .slideshow AND .banner classes
    document.querySelectorAll('.slideshow.banner').forEach(stripHeight);
  }

  fixBanners();
  document.addEventListener('DOMContentLoaded', fixBanners);
  window.addEventListener('load', fixBanners);

  // MutationObserver: watch for Sense JS setting inline styles and strip immediately
  document.addEventListener('DOMContentLoaded', function () {
    var banners = document.querySelectorAll('.slideshow.banner');
    if (!banners.length) return;
    var obs = new MutationObserver(function (mutations) {
      if (window.innerWidth >= 750) return;
      mutations.forEach(function (m) {
        if (m.attributeName === 'style') stripHeight(m.target);
      });
    });
    banners.forEach(function (el) {
      obs.observe(el, { attributes: true, attributeFilter: ['style'] });
    });
  });
})();
